import styled, { css } from 'styled-components';

export default {
  Wrapper: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;

    @media (min-width: 768px) {
      flex-direction: row;
      overflow: hidden;
    }
  `,
  Layout: styled.div<{ isFullscreen: boolean; withSidebar: boolean }>`
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    flex-shrink: 0;
    order: 1;

    @media (min-width: 768px) {
      position: relative;
      min-height: 320px;
      flex-shrink: 1;
      order: 2;
    }
  `,
  CloseButton: styled.button<{ isPeriodical: boolean }>`
    padding: 16px;
    position: absolute;
    top: 6px;
    right: 10px;
    border: 0;
    background: transparent;
    outline: none;
    z-index: 9993;
    font-size: 16px;
    opacity: 0.4;

    ${(props) =>
      props.theme.isRtl &&
      css`
        right: auto;
        left: 10px;
      `}

    svg {
      fill: black;
    }

    &:hover {
      opacity: 1;
    }

    @media screen and (max-width: 700px) {
      position: absolute;
      padding: 14px 18px;
      top: 0;
      right: 0;
    }

    ${(props) =>
      props.isPeriodical &&
      css`
        top: 0;
        /* right: auto; */
        padding: 11px 14px;

        @media screen and (max-width: 700px) {
          padding: 7px 11px;
        }
      `}
  `,
};
